// extracted by mini-css-extract-plugin
export var expandedRowWrapper = "_2o-6";
export var headerCell = "_2o-2";
export var loadingStateContent = "_2o-8";
export var rowWrapper = "_2o-4";
export var stickyAggregationCell = "_2o-b";
export var stickyAggregationRow = "_2o-7";
export var stickyColumnCell = "_2o-a";
export var stickyColumnHeaderCell = "_2o-9";
export var table = "_2o-1";
export var virtualRowWrapper = "_2o-5";
export var virtualTableBodyFiller = "_2o-d";
export var virtualTableBodyFillerBottom = "_2o-e";
export var virtualTableContainer = "_2o-0";
export var virtualTableContainerFill = "_2o-c";
export var white = "_2o-3";